/**
 * CS: Prevent page-transition glitch on same-page navigation.
 * When user clicks a link to the current page (e.g., logo on home page),
 * Horizon's View Transitions API triggers a full fade+slide animation
 * even though the content is identical — causing a visual "ghost" effect.
 * This intercepts those clicks and smooth-scrolls to top instead.
 */
(function () {
  if (window.__csSamePageScrollInit) return;
  window.__csSamePageScrollInit = true;

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link) return;

    var href = link.getAttribute('href');
    var currentPath = window.location.pathname;

    // Normalize: both "/" and "" mean root
    var isRootLink = href === '/' || href === '';
    var isOnRoot = currentPath === '/' || currentPath === '';

    if (isRootLink && isOnRoot) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });
})();
